import moment from 'moment';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { concat, from, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { EmployeeInfoService } from '../../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { EmployeeService } from './../../../../pages/employee/services/employee.service';
import { EventService } from 'src/app/core/services/event.service';
import { UtilityService } from '../../../../core/services/utility.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { WarningModalComponent } from '../../../shared/warning-modal/warning-modal.component';


@Component({
  selector: 'app-submit-expense-modal',
  templateUrl: './submit-expense-modal.component.html',
  styleUrls: ['./submit-expense-modal.component.css']
})
export class SubmitExpenseModalComponent implements OnInit {
  @Input() data: any;
  @Input() mode: string;
  @Input() selectedEmployee: any;
  portalSettings: any;
  employeeInfo: any;
  currencySymbol: string;
  mobileMode: boolean;
  showTaxAmount: boolean;
  showReviewer: boolean;
  submitting: boolean;
  formData: { [key: string]: any } = {};
  total: number;
  submitString: string;
  Reviewer: any[];
  userAction: string;
  selectedData: any[];
  format: string;
  transDateDaysLimit: string;

  reviewer$: Observable<any>;
  reviewerInput$ = new Subject<any>();
  reviewerList: any[];
  reviewerLoading = false;

  constructor(public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private employeeService: EmployeeService, public HttpClient: HttpClient, private eventService: EventService, private utilityService: UtilityService, private sharedModalService: BsModalService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    var currencyFormatSymbols = this.portalSettings.CurrencyFormatPerPRCo.ConfigValue;
    this.currencySymbol = "$";
    if (currencyFormatSymbols && currencyFormatSymbols.trim() !== "") {
      currencyFormatSymbols.split(",").forEach((val: string) => {
        var arrayEntry = val.split(":");
        var currencyObject = { PRCo: parseInt(arrayEntry[0]), Currency: arrayEntry[1] }
        if (this.employeeInfo && currencyObject.PRCo == this.employeeInfo.PRCo) {
          this.currencySymbol = currencyObject.Currency;
        }
      });
    }
    this.mobileMode = this.mobileAndTabletcheck();
    this.showTaxAmount = this.portalSettings.EXShowTaxAmountOnApproval.ConfigValue == "1" ? true : false;
    this.showReviewer = this.portalSettings.ReviewerOnSubmit.ConfigValue == "1" ? true : false;
    this.transDateDaysLimit = this.portalSettings["EXRestrictTransactionDateNumberofDays"].ConfigValue;
    this.submitting = false;
    this.formData = {};
    this.selectedData = [];
    this.total = 0;

    this.submitString = "";
    if (this.mode == "multi") {
      this.data.forEach((val: any) => {
        if (val.Selected) {
          this.selectedData.push(val);
          this.submitString += val.ExpenseItemID + ",";
          this.total += val.Amount;
        }
      });
    }

    this.formData.selectedReviewer = {};
    this.Reviewer = [];
    this.reviewerList = [];
    this.registerLookups();
  }

  mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  private registerLookups() {
    //register observables used by super lookups

    this.reviewer$ = concat(
      this.reviewerInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(term => ((term != null && term.length > 1) ?
          from(this.employeeService.getReviewers(term)).pipe(
            catchError(() => of([]))) : of([])
        ))
      )
    );
  }

  addReviewer() {
    this.reviewerList.push(this.formData.selectedReviewer.Value);
    this.formData.selectedReviewer.Value = null;
  }

  removeReviewer(data, index) {
    this.reviewerList.splice(index, 1);
  }

  submitClicked() {
    if (this.employeeInfo.IsExpenseAdmin && this.transDateDaysLimit != null && this.selectedData?.length > 0) {
      var isTransDateRestricted = false;
      let warningMessage: string = null;
      var restrictedTransDate = moment(new Date()).subtract(this.transDateDaysLimit, "days").format(this.format);
      this.selectedData.forEach((val: any) => {
        var transDate = moment(val.ExpenseDateDisplay).format(this.format);
        if (transDate < restrictedTransDate) {
          isTransDateRestricted = true;
        }
      });
      if (isTransDateRestricted && this.selectedData.length == 1) {
        warningMessage = 'Transaction date is beyond allowed expense date.  Are you sure you want to continue?';
      }
      else if (isTransDateRestricted && this.selectedData.length > 1) {
        warningMessage = 'Transaction date is beyond allowed expense date for one or more expense items.  Are you sure you want to continue?';
      }
      if (isTransDateRestricted && warningMessage != null) {
        const initialState = {
          modalData: {
            modalTitle: "Confirm Message",
            modalMessage: warningMessage,
            modalAction: "Continue", closeButtonText: "Cancel", warningLevel: "success"
          },
          backdrop: 'static',
          size: 'md'
        };
        let modalRef = this.sharedModalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
        modalRef.onHide.subscribe((reason: any) => {
          var result = modalRef.content;
          if (result.userAction == "Continue") {
            this.submitItems();
          }
        });
      }
      else {
        this.submitItems();
      }
    }
    else {
      this.submitItems();
    }
  }

  submitItems() {
    this.submitting = true;
    this.employeeService.submitItems((this.mode == "multi" ? this.submitString : this.data.ExpenseItemID), this.formData.optionDescription, this.selectedEmployee.UserKeyID).then((response: any) => {
      if (response.success) {
        this.eventService.broadcast('approvedExpenseChangedBroadcast');
        var reviewerArray = [];
        this.reviewerList.forEach((val: any) => {
          reviewerArray.push(val.Reviewer);
        });
        this.userAction = "submit";
        if (reviewerArray.length > 0) {
          this.employeeService.addReviewer(response.newID, reviewerArray).then((response: any) => {
            this.activeModal.close('submit');
          });
        } else {
          this.activeModal.close('submit');
        }
      } else {
        this.activeModal.close('submit');
      }
    });
  }

  cancelClicked() {
    this.activeModal.close();
  }
}
